import React from "react";
import "./Poll.scss";

function Q3AnswerCopy({ pollQuestions }) {
  return (
    <p className="poll__question">
      <span className="poll__question--bold">{pollQuestions.answer}</span>
      <sup className="poll__question--sup">{pollQuestions.sup}</sup>
      {pollQuestions.aCopy1}
    </p>
  );
}

export default Q3AnswerCopy;
